import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const other = new Restful(project, 'other/report')

other.export = function(type) {
  const url = project + 'other/report/' + type
  return http.get(url).then(res => {
    return res
  })
}

other.download = function(type) {
  const url = project + 'other/report/' + type + '/download'
  return http.octetget(url).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

export default other
